var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "trophy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-4",
    transform: "translate(-532.000000, -379.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 131,
    transform: "translate(532.000000, 379.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,3 L18,3 L18,6.02514648 L18,9.00117666 C18,12.3142353 15.3069658,15 12,15 C8.6862915,15 6,12.3225826 6,8.99353135 L6,5.99499512 L6,3 Z",
    id: "Rectangle-8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,19.0016228 L15.0029699,19.0016228 C15.5536144,19.0016228 16,19.4453976 16,20.0014199 C16,20.0014876 16,20.0015552 16,20.0016228 L17.9931545,20.0016228 C18.5492199,20.0016228 19,20.4453976 19,21.0014199 C19,21.5535927 18.5500512,22.0012171 17.9931545,22.0012171 L6.00684547,22.0012171 C5.45078007,22.0012171 5,21.5574423 5,21.0014199 C5,20.4492472 5.44994876,20.0016228 6.00684547,20.0016228 L8.00000002,20.0016228 C8.00000001,20.0015552 8,20.0014876 8,20.0014199 C8,19.4492472 8.45303631,19.0016228 8.99703014,19.0016228 L11,19.0016228 L11,15.0016228 L13,15.0016228 L13,19.0016228 Z",
    id: "Combined-Shape",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,5 C18,5 20.5,5 21,5 C21.5,5 22,5.5 22,6 C22,6.5 22,11 17,11",
    id: "Path-49",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,5 C3,5 5.5,5 6,5 C6.5,5 7,5.5 7,6 C7,6.5 7,11 2,11",
    id: "Path-49",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round",
    transform: "translate(4.500000, 8.000000) scale(-1, 1) translate(-4.500000, -8.000000) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.52c3bd1ade49acb8916f6eb582ea08e3.svg";
export { ForwardRef as ReactComponent };